import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './AkunPengenaanPajak.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

var _baseId = "mod-table-akun-pajak"

const AkunPengenaanPajakTable = ({
  className       = '',
  history,
  akunId
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={''}
      className={className}
      showCommandbar={false}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="dasarHukum"
      columns={[
        {
          label: 'Jurnal',
          searchable: true,
          key: 'jurnal',
          type: TableWrapper.dataTypes.STRING,
          render: item => {
            var items = item.kondisis
            if(!items) items = []

            return <div>
              {items.map((v, i)=> {
                return <p key={i}>{v.lawanAkun.nomor} - {v.lawanAkun.nama} ({v.posisiLawanAkun})</p>
              })}
            </div>
          }
        },
        {
          label: 'KOP',
          searchable: true,
          key: 'kop',
          type: TableWrapper.dataTypes.STRING,
          render: item => {
            var items = item.kops
            if(!items) items = []
            return <div>
              {items.map((v, i)=> {
                return <p key={i}>{v.kodeObjekPajak.kode} - {v.kodeObjekPajak.nama}</p>
              })}
            </div>
          }
        },
        {
          label: 'Dasar Hukum',
          searchable: true,
          key: 'dasarHukum',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.dasarHukum)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push(`/onpremise/akun-pajak/baru/${akunId}`), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/akun-pajak/${item.id}/${akunId}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        query['akunId.equals'] = akunId
        return service.get(query)
      }}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default AkunPengenaanPajakTable
